import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import InputList from "../../../shared/components/presentation/input-list/InputList";
import { Grid, GridItem } from "../../../shared/components/presentation/grid/Grid";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as webAppointmentActions from "../../actions/webAppointmentActions";
import * as defaultState from "../../constants/DefaultState";
import * as strings from "../../constants/strings";
import "./ErrorReviewPage.css";
import { clearState } from '../../functions/loadState'

export class ErrorReviewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  formatDate(date) {
    // Convert from a date formatted line "1982-06-23" to something like "06/23/1982"
    if (date.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/)) {
      return date.substring(5, 7) + "/" + date.substring(8) + "/" + date.substring(0, 4);
    }
    return date;
  }

  formatPhoneNumber(phone) {
    // Convert pretty much any string with a reasonable number of digits into a US phone number
    phone.replace(/[^0-9]/g, "");
    switch (phone.length) {
      case 7:
        return phone.substring(0, 3) + "." + phone.substring(3);
      case 10:
        return phone.substring(0, 3) + "." + phone.substring(3, 6) + "." + phone.substring(6);
      case 11:
        if (phone.substring(0, 1) === "1") {
          return "1" + phone.substring(1, 4) + "." + phone.substring(4, 7) + "." + phone.substring(7);
        }
        break;
      default:
        break;
    }
    return phone;
  }

  formatDaysAndTimes(appointment) {
    let days = appointment.day; // days are stored as bits in a single int
    const times = appointment.time; // times are stored as bits in a single int
    const daysArray = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"];
    const wantsFirstAvailableDay = days === 0 || days === 31;
    const wantsFirstAvailableTime = times === 0 || times === 3;
    const timeOfDay = times === 1 ? "morning" : "afternoon";

    if (wantsFirstAvailableDay) {
      if (wantsFirstAvailableTime) {
        return "First available day and time";
      }
      return `First available ${timeOfDay}`;
    }

    // This loops over each bit in the days byte and pushes the corresponding
    // day into the wantedDays array
    let wantedDays = [];
    for (let i = 0; i < 5; i++) {
      if (days & (1 << i)) {
        days ^= (1 << i);
        wantedDays.push(daysArray[i]);
      }
    }

    let formattedDays = "";
    if (wantedDays.length > 2) {
      formattedDays = `${[...wantedDays].slice(0, -1).join(", ")} or ${wantedDays[wantedDays.length - 1]}`;
    } 
    else if (wantedDays.length === 2) {
      formattedDays = `${wantedDays[0]} or ${wantedDays[1]}`;
    } 
    else {
      formattedDays = wantedDays[0] ? wantedDays[0] : "";
    }

    return `${wantsFirstAvailableTime ? "First available on " : ""}${formattedDays}${!wantsFirstAvailableTime ? ` ${timeOfDay}` : ""}`;
  }

  determinePolicyHolderString(relation) {
    if (relation === "Other") {
      return `${this.props.state.insurance.policyHolder.firstName} ${this.props.state.insurance.policyHolder.lastName}`;
    } 
    else if (relation === strings.ME) {
      return "Me";
    } 
    else if (relation === strings.THE_PATIENT) {
      return "The patient";
    }
    return this.props.state.forMe ? `My ${relation.toLowerCase()}` : `The patient’s ${relation.toLowerCase()}`;
  }

  determinePolicyHolderAddressString(whereToSend) {
    const relation = this.props.state.insurance.billing.relation;
    const firstName = this.props.state.insurance.billing.firstName;
    const lastName = this.props.state.insurance.billing.lastName;
    const formattedFirstName = firstName.charAt(0).toUpperCase() + firstName.slice(1);
    const formattedLastName = lastName.charAt(0).toUpperCase() + lastName.slice(1);

    if (whereToSend === strings.TO_MY_ADDRESS || whereToSend === strings.TO_PATIENTS_ADDRESS) {
      return whereToSend;
    }
    if (relation === "Other") {
      return `To ${formattedFirstName} ${formattedLastName}`;    
    }
    return this.props.state.forMe ? `To my ${relation.toLowerCase()}` : `To the patient’s ${relation.toLowerCase()}`;
  }

  valid() {
    return true;
  }

  render() {
    const { paymentMethod, appointment, insurance, patientSeenRecently, forMe } = this.props.state;
    const header = "It looks like something went wrong and we're unable to submit your appointment request. We're so sorry.";
    const paragraphHeader = "We want to help you successfully schedule your appointment. Here's what to do next:"
    const title =  'Your entry';

    // The first paragraph is common, regardless of appt location.
    const subtitle = "All of the information you've entered is below. You will need this information handy when speaking to someone in the appointment center.";

     // We can't search the location for "OH", because some Ohio locations don't
    // include that.  e.g. "Medina Medical Office Building".  This could get
    // more obnoxious as we work with more departments and locations, possibly
    // in more states and/or countries.
    const isOhioOrNevada = appointment.location && !appointment.location.includes("Florida");

    const shouldShowPolicyHolderFields = 
      insurance.policyHolder.relation !== strings.ME &&
      insurance.policyHolder.relation !== strings.THE_PATIENT &&
      !patientSeenRecently &&
      paymentMethod === "insurance";

    const shouldShowBillingName = insurance.whereToSend === strings.SOMEWHERE_ELSE;

    const shouldShowBillingAddr = 
      shouldShowBillingName || 
      (!forMe && insurance.whereToSend === strings.TO_MY_ADDRESS);

    const shouldShowBillingDob = 
      shouldShowBillingAddr &&
      (
        (insurance.policyHolder.firstName !== insurance.billing.firstName) ||
        (insurance.policyHolder.lastName !== insurance.billing.lastName) ||
        (insurance.policyHolder.relation !== insurance.billing.relation) ||
        (insurance.policyHolder.dob !== insurance.billing.dob)
      );

    let inputlist = [
      !this.props.state.forMe ? 
        {
            fieldsetLegend: "Your Contact Information",
            fieldsetColumns: 1,
            className: "review-list-fieldset",
            inputs: [
              {
                type: "text",
                id: "contact-relation",
                isEditable: false,
                label: "Your relationship to the patient:",
                existingContent: this.props.state.contact.relation
              },
              {
                type: "text",
                id: "name",
                isEditable: false,
                label: "Your name:",
                existingContent: `${this.props.state.contact.firstName} ${this.props.state.contact.lastName}`
              },
              {
                type: "text",
                id: "email",
                isEditable: false,
                label: "Your email:",
                existingContent: this.props.state.contact.email
              },
              {
                type: "text",
                id: "phone",
                isEditable: false,
                label: "Your phone number:",
                existingContent: this.formatPhoneNumber(this.props.state.contact.phone)
              }
            ]
        } : null, // End of Contact Info fieldset.

      // Either the new patient or established patient info.
      this.props.state.patientSeenRecently ? 
        {
            fieldsetLegend: "Patient Information", // Established Patient info
            fieldsetColumns: 1,
            className: "review-list-fieldset",
            inputs: [
              {
                type: "text",
                id: "established-patient-name",
                isEditable: false,
                label: !this.props.state.forMe ? "Patient’s name:" : "Name:",
                existingContent: `${this.props.state.patient.firstName} ${this.props.state.patient.lastName}`
              },
              this.props.state.forMe ? 
                {
                    type: "text",
                    id: "established-patient-email",
                    isEditable: false,
                    label: "Email:",
                    existingContent: this.props.state.patient.email
                } : null,
              {
                type: "text",
                id: "established-patient-phone",
                isEditable: false,
                label: !this.props.state.forMe ? "Patient’s phone number:" : "Phone number:",
                existingContent: this.formatPhoneNumber(this.props.state.patient.phone)
              },
              {
                type: "text",
                id: "established-patient-dob",
                isEditable: false,
                label: !this.props.state.forMe ? "Patient’s date of birth:" : "Date of birth:",
                existingContent: this.formatDate(this.props.state.patient.dob)
              },
              {
                type: "text",
                id: "established-patient-ssn",
                isEditable: false,
                label: this.props.state.forMe ? "Social Security Number:" : "Patient’s Social Security Number:",
                existingContent: this.props.state.patient.ssn ? `Ending in ${this.props.state.patient.ssn}` : strings.NOT_PROVIDED
              }
            ]
          } : // end of Established Patient info fieldset
          {
            fieldsetLegend: "Patient Information", // New Patient info
            fieldsetColumns: 1,
            className: "review-list-fieldset",
            inputs: [
              {
                type: "text",
                id: "new-patient-name",
                isEditable: false,
                label: !this.props.state.forMe ? "Patient’s name:" : "Name:",
                existingContent: `${this.props.state.patient.firstName} ${this.props.state.patient.lastName}`
              },
              {
                type: "text",
                id: "new-patient-gender",
                isEditable: false,
                label: !this.props.state.forMe ? "Patient’s gender:" : "Gender:",
                existingContent: this.props.state.patient.gender
              },
              {
                type: "text",
                id: "new-patient-marital-status",
                isEditable: false,
                label: !this.props.state.forMe ? "Patient’s marital status:" : "Marital status:",
                existingContent: this.props.state.patient.maritalStatus
              },
              {
                type: "text",
                id: "new-patient-dob",
                isEditable: false,
                label: !this.props.state.forMe ? "Patient’s date of birth:" : "Date of birth:",
                existingContent: this.formatDate(this.props.state.patient.dob)
              },
              {
                type: "text",
                id: "new-patient-address",
                isEditable: false,
                label: !this.props.state.forMe ? "Patient’s address:" : "Address:",
                existingContent: (
                  <div>
                    {this.props.state.patient.address1}, {this.props.state.patient.address2}
                    {this.props.state.patient.address2 ? ", " : ""}
                    <br className="mobile-break" />
                    {this.props.state.patient.city}, {this.props.state.patient.state} {this.props.state.patient.zip}
                  </div>
                )
              },
              this.props.state.forMe ? 
                {
                    type: "text",
                    id: "new-patient-email",
                    isEditable: false,
                    label: "Email:",
                    existingContent: this.props.state.patient.email
                } : null,
                {
                  type: "text",
                  id: "new-patient-phone",
                  isEditable: false,
                  label: !this.props.state.forMe ? "Patient’s phone number" : "Phone number:",
                  existingContent: this.props.state.patient.phone ? this.formatPhoneNumber(this.props.state.patient.phone) : strings.NOT_PROVIDED
                }
            ]
          }, // end of New Patient info fieldset

      {
        fieldsetLegend: "Appointment Information",
        fieldsetColumns: 1,
        className: "review-list-fieldset",
        inputs: [
          {
            type: "text-area",
            id: "reason",
            isEditable: false,
            label: "Reason for visit:",
            existingContent: this.props.state.appointment.reason
          },
          {
            type: "text-area",
            id: "diagnosis",
            isEditable: false,
            label: "Diagnosis:",
            existingContent: this.props.state.appointment.diagnosis ? this.props.state.appointment.diagnosis : strings.NOT_PROVIDED
          },
          (this.props.state.appointment.translationInterpretationServices.needServices) ?
            {
                type: "text",
                id: "interpretation-service",
                isEditable: false,
                label: "Interpretation service needed:",
                existingContent: this.props.state.appointment.translationInterpretationServices.whichService === strings.ASL ? "ASL interpretation" : this.props.state.appointment.translationInterpretationServices.language
            } : null,
          ((this.props.state.appointment.translationInterpretationServices.needServices && this.props.state.appointment.translationInterpretationServices.whichService === strings.ASL) ||
            (!this.props.state.appointment.translationInterpretationServices.needServices)) ?
            {
              type: "text",
              id: "primary-language",
              isEditable: false,
              label: "Primary language:",
              existingContent: this.props.state.appointment.translationInterpretationServices.language
            } : null,
          this.props.state.appointment.referringPhysician.haveReferringPhys ? 
            {
                type: "text",
                id: "ref-phys",
                isEditable: false,
                label: "Referring physician:",
                existingContent: this.props.state.appointment.referringPhysician.firstName + " " + this.props.state.appointment.referringPhysician.lastName
            } : null,
          this.props.state.appointment.referringPhysician.haveReferringPhys ? 
            {
                type: "text",
                id: "ref-phys-phone",
                isEditable: false,
                label: "Referring physician’s phone number:",
                existingContent: this.formatPhoneNumber(this.props.state.appointment.referringPhysician.phone)
            } : null,
          {
            type: "text",
            id: "specialty-dept",
            isEditable: false,
            label: "Specialty:",
            existingContent: this.props.state.appointment.department.split("|")[1]
          },
          {
            type: "text",
            id: "location",
            isEditable: false,
            label: "Preferred location:",
            existingContent: this.props.state.appointment.location.split("|")[1]
          },
          {
            type: "text",
            id: "preferred-phys",
            isEditable: false,
            label: "Preferred provider:",
            existingContent: this.props.state.appointment.provider ? this.props.state.appointment.provider : strings.NOT_PROVIDED
          },
          {
            type: "text",
            id: "visit-type",
            isEditable: false,
            label: "Kind of visit:",
            existingContent: this.props.state.appointment.type === "Virtual" ? "Virtual (if available)" : this.props.state.appointment.type
          },
          {
            type: "text",
            id: "day-w",
            isEditable: false,
            label: "Preferred day and time:",
            existingContent: this.formatDaysAndTimes(this.props.state.appointment)
          }
        ]
      }, // end of Appointment Info fieldset

      this.props.state.paymentMethod === "out-of-pocket" ? 
        {
            // OOP fieldset
            fieldsetLegend: "Payment Information",
            fieldsetColumns: 1,
            className: "review-list-fieldset",
            inputs: [
              {
                type: "text",
                id: "oop-payment-method",
                isEditable: false,
                label: "Payment method:",
                existingContent: "Out-of-pocket"
              },
              {
                type: "text",
                id: "oop-pfa-info",
                isEditable: false,
                label: "For financial clearance:",
                existingContent: isOhioOrNevada ? "Schedule a callback appointment." : "You can expect a call from a PFA within 24-48 hours to complete your request."
              }
            ]
        } : null, // end of OOP fieldset

      this.props.state.paymentMethod === "insurance" ? 
        {
          // Insurance fieldset
          fieldsetLegend: "Insurance Information",
          fieldsetColumns: 1,
          className: "review-list-fieldset",
          inputs: [
            {
              type: "text",
              id: "ins-company",
              isEditable: false,
              label: "Name of insurance company:",
              existingContent: this.props.state.insurance.company
            },
            {
              type: "text",
              id: "ins-product",
              isEditable: false,
              label: "Product type:",
              existingContent: this.props.state.insurance.policyType
            },
            {
              type: "text",
              id: "ins-policy-number",
              isEditable: false,
              label: "Policy or ID number:",
              existingContent: this.props.state.insurance.policyNumber
            },
            {
              type: "text",
              id: "ins-group",
              isEditable: false,
              label: "Group number:",
              existingContent: this.props.state.insurance.group ? this.props.state.insurance.group : strings.NOT_PROVIDED
            },

              // Start of insurance fields to include for policy holder.
              !this.props.state.patientSeenRecently && this.props.state.insurance.policyHolder.relation !== "Other" ? 
                {
                    type: "text",
                    id: "ins-policy-holder",
                    isEditable: false,
                    label: "Policy holder:",
                    existingContent: this.determinePolicyHolderString(this.props.state.insurance.policyHolder.relation)
                } : null,
              shouldShowPolicyHolderFields ? 
                {
                    type: "text",
                    id: "ins-policy-name",
                    isEditable: false,
                    label: "Policy holder’s name:",
                    existingContent: `${this.props.state.insurance.policyHolder.firstName} ${this.props.state.insurance.policyHolder.lastName}`
                } : null,
              shouldShowPolicyHolderFields ? 
                {
                    type: "text",
                    id: "ins-policy-dob",
                    isEditable: false,
                    label: "Policy holder’s date of birth:",
                    existingContent: this.formatDate(this.props.state.insurance.policyHolder.dob)
                } : null,
              shouldShowPolicyHolderFields ? 
                {
                    type: "text",
                    id: "ins-policy-email",
                    isEditable: false,
                    label: "Policy holder’s email:",
                    existingContent: this.props.state.insurance.policyHolder.email
                } : null,
              // End of insurance fields to include for policy holder.

              // Start of insurance fields to include for billing and billing address.
              {
                type: "text",
                id: "ins-billing-where-to-send",
                isEditable: false,
                label: "Where to send the bill:",
                existingContent: this.determinePolicyHolderAddressString(this.props.state.insurance.whereToSend)
              },
              shouldShowBillingName && this.props.state.insurance.billing.relation !== "Other" ?
                {
                    type: "text",
                    id: "ins-billing-name",
                    isEditable: false,
                    label: "Their name:",
                    existingContent: `${this.props.state.insurance.billing.firstName} ${this.props.state.insurance.billing.lastName}`
                } : null,
              shouldShowBillingDob ? 
                {
                    type: "text",
                    id: "ins-billing-dob",
                    isEditable: false,
                    label: (this.props.state.insurance.whereToSend === strings.TO_MY_ADDRESS ? "Your" : "Their") + " date of birth:",
                    existingContent: this.formatDate(this.props.state.insurance.billing.dob)
                } : null,
              shouldShowBillingAddr ? 
                {
                    type: "text",
                    id: "ins-billing-addr",
                    isEditable: false,
                    label: (this.props.state.insurance.whereToSend === strings.TO_MY_ADDRESS ? "Your" : "Their") + " address:",
                    existingContent: (
                      <div>
                        {this.props.state.insurance.billing.address1}, {this.props.state.insurance.billing.address2}
                        {this.props.state.insurance.billing.address2 ? ", " : ""}
                        <br className="mobile-break" />
                        {this.props.state.insurance.billing.city}, {this.props.state.insurance.billing.state} {this.props.state.insurance.billing.zip}
                      </div>
                    )
                } : null
          ]
        } : null, // end of Insurance fieldset

      {
        fieldsetLegend: "",
        fieldsetColumns: 1,
        className: "button-order margin-top-medium",
        inputs: [
          {
            type: "button",
            id: "close",
            className: "btn--primary",
            value: "Close",
            onClick: () => {
              this.props.webAppointmentClearOutData();
              clearState();
              window.location.href = "https://my.clevelandclinic.org/patients/information/access";
            }
          }
        ]
      }
    ];

    return (
      <React.Fragment>
        <Grid columns={1}>
          <GridItem>
            <div className="web-appt__header">
              <div className="error-review">
                <h1>{header}</h1>
                <hr className="error-review__hr"/>
                <h4>{paragraphHeader}</h4>
                <ul>
                  <li>Don't close this browser.</li>
                  <li>
                    Call our appointment center at{' '}
                    <a href="tel:8002232273">800.223.2273</a>.
                  </li>
                  <li>Scroll down to see the information you entered.</li>
                </ul>
                <span/>
                <h2>{title}</h2>
                <p className="error-review__subtitle">{subtitle}</p>
              </div>
            </div>
          </GridItem>
        </Grid>
        <InputList inputs={inputlist} isInlineList={false} />
      </React.Fragment>
    );
  }
};

ErrorReviewPage.propTypes = {
  state: defaultState.statePropType,
  webAppointmentClearOutData: PropTypes.func.isRequired,
  webAppointmentSetRequestResults: PropTypes.func.isRequired
};

function mapStateToProps(state ) {
  return {
    state: state.webAppointmentForm // That’s right, the whole webappointment state.
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    webAppointmentClearOutData: () => dispatch(webAppointmentActions.webAppointmentClearOutData()),
    webAppointmentSetRequestResults: (value) => dispatch(webAppointmentActions.webAppointmentSetRequestResults(value))
  };
};

// connects component to redux, and passes along the router
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ErrorReviewPage));
// For testing
export const UnwrappedPageComponent = ErrorReviewPage;